import { render, staticRenderFns } from "./NewStock.vue?vue&type=template&id=7d5375e6&scoped=true&"
import script from "./NewStock.vue?vue&type=script&lang=ts&"
export * from "./NewStock.vue?vue&type=script&lang=ts&"
import style0 from "./NewStock.vue?vue&type=style&index=0&id=7d5375e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5375e6",
  null
  
)

export default component.exports